/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef} from 'react'

/**
 * @public
 */
export const PinRemovedIcon = forwardRef(function PinRemovedIcon(
  props: React.SVGProps<SVGSVGElement>,
  ref: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      data-sanity-icon="pin-removed"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0757 20.9243L12.5 21.3485L12.9243 20.9243C14.4315 19.417 15.9655 17.7584 17.1242 16.0203C17.5402 15.3963 17.9127 14.7549 18.2192 14.1H16.8785C16.6575 14.5172 16.4051 14.9356 16.1258 15.3547C15.1381 16.8362 13.8436 18.2803 12.5 19.6478C11.1564 18.2803 9.86189 16.8362 8.87423 15.3547C8.59486 14.9356 8.34249 14.5172 8.12154 14.1H6.78084C7.08725 14.7549 7.45976 15.3963 7.87577 16.0203C9.03448 17.7584 10.5685 19.417 12.0757 20.9243ZM19.1 10.5C19.1 10.9701 19.0508 11.4372 18.9594 11.9H17.732C17.8418 11.4297 17.9 10.9627 17.9 10.5C17.9 7.33137 15.6686 5.1 12.5 5.1C9.33137 5.1 7.1 7.33137 7.1 10.5C7.1 10.9627 7.15822 11.4297 7.26799 11.9H6.04056C5.94923 11.4372 5.9 10.9701 5.9 10.5C5.9 6.66863 8.66863 3.9 12.5 3.9C16.3314 3.9 19.1 6.66863 19.1 10.5ZM14.6 10.5C14.6 11.0379 14.3978 11.5285 14.0653 11.9H10.9347C10.6022 11.5285 10.4 11.0379 10.4 10.5C10.4 9.3402 11.3402 8.4 12.5 8.4C13.6598 8.4 14.6 9.3402 14.6 10.5ZM11.6 10.5C11.6 10.0029 12.0029 9.6 12.5 9.6C12.9971 9.6 13.4 10.0029 13.4 10.5C13.4 10.9971 12.9971 11.4 12.5 11.4C12.0029 11.4 11.6 10.9971 11.6 10.5ZM2 13.6H23V12.4H2V13.6Z"
        fill="currentColor"
      />
    </svg>
  )
})
